/* import __COLOCATED_TEMPLATE__ from './course-pill.hbs'; */
import Component from '@glimmer/component';
import type CourseModel from 'codecrafters-frontend/models/course';

interface Signature {
  Element: HTMLDivElement;

  Args: {
    course: CourseModel;
    isSelected: boolean;
  };
}

export default class CoursePillComponent extends Component<Signature> {}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'VotePage::CoursePill': typeof CoursePillComponent;
  }
}
